import { Link } from "react-router-dom";
import PageBanner from "./PageBanner";
import SocialMediaSidebar from "./SocialMediaSidebar";
import SectionHeader from "./SectionHeader";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaFirefoxBrowser,
} from "react-icons/fa";
import React, { useState } from "react";
import mapimage from "../assets/images-webp/mapimage.webp";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
import { EcomAPI, CMSAPI } from "../config";
import ScrollToTopButton from "./ScrollToTopButton";
import SectionHeaderNoPDF from "./SectionHeaderNoPDF";

const Contact = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    project: "",
    subject: "",
    message: "",
  });
  const [errors, setErrors] = useState({
    phone: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validatePhone = (phone) => {
    const phoneRegex = /^[6-9]\d{9}$/;
    return phoneRegex.test(phone);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phone') {
      setErrors({
        ...errors,
        phone: value && !validatePhone(value) ? 'Please enter a valid 10-digit Indian mobile number' : ''
      });
    }
    
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validatePhone(formData.phone)) {
      setErrors({
        ...errors,
        phone: 'Please enter a valid 10-digit Indian mobile number'
      });
      return;
    }
    
    setIsSubmitting(true);

    try {
      const bodyContent = `
       <p>Name: ${formData.name}</p></br>
       <p>Email: ${formData.email}</p></br>
       <p>Phone: ${formData.phone}</p></br>
       <p>Project: ${formData.project}</p></br>
       <p>Subject: ${formData.subject}</p></br>
       <p>Message: ${formData.message}</p>
      `;

      const response = await axios.post(
        `${CMSAPI}/api/Website/send-mail`,
        null,
        {
          params: {
            name: formData.name,
            customeremail: "presales@ajeevi.com",
            subject: formData.subject || "Contact Form Submission",
            body: bodyContent,
          },
        }
      );

      if (response.data === "OK") {
        toast.success("Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          project: "",
          subject: "",
          message: "",
        });
      } else {
        throw new Error("Failed to send message");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div>
        <SocialMediaSidebar />
        <Toaster position="top-center" />
      </div>
      <PageBanner
        title="Contact Us"
        breadcrumb={[{ label: "Home", href: "/" }, { label: "Contact Us" }]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeaderNoPDF
          title="Contact Us @ AJEEVI"
          shareUrl="https://swachhajv.ajeevi.in/contact"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full bg-white px-4 sm:px-6 md:px-10 lg:px-28 py-3">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-10">
            {/* Left: Contact Info & Form */}
            <div>
              {/* Contact Form */}
              <div className="bg-gray-100 p-2 rounded-lg mb-8">
                <h3 className="text-[#00D084] text-2xl text-center font-semibold">
                  Got any questions? Don't hesitate to get in touch.
                </h3>

                <form className="space-y-4 p-4" onSubmit={handleSubmit}>
                  <div className="grid md:grid-cols-3 gap-1 text-lg">
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                      className="p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#00D084]"
                      required
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChange}
                      className="p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#00D084]"
                      required
                    />
                    <div>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Your Phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#00D084]"
                        required
                        maxLength="10"
                      />
                      {errors.phone && (
                        <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
                      )}
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-1 text-lg">
                    <input
                      type="text"
                      name="project"
                      placeholder="Your Project"
                      value={formData.project}
                      onChange={handleChange}
                      className="p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#00D084]"
                    />
                    <input
                      type="text"
                      name="subject"
                      placeholder="Subject"
                      value={formData.subject}
                      onChange={handleChange}
                      className="p-3 text-lg border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#00D084]"
                    />
                  </div>

                  <textarea
                    name="message"
                    placeholder="Message"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full p-3 text-lg border border-gray-300 rounded h-14 resize-none focus:outline-none focus:ring-2 focus:ring-[#00D084]"
                    required
                  />
                  <button
                    type="submit"
                    className="w-full bg-[#00D084] text-white text-lg py-3 rounded hover:bg-[#00b472] transition disabled:opacity-50"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Sending..." : "Send Message"}
                  </button>
                </form>
              </div>
            </div>

            {/* Right: Google Map */}
            <div className="hidden relative w-full h-full rounded overflow-hidden">
              {!isLoaded && (
                <img
                  src={mapimage}
                  alt="Loading map"
                  className="absolute top-0 left-0 w-full h-full object-cover filter blur-sm transition-opacity duration-500"
                />
              )}

              <iframe
                src="https://maps.google.com/maps?q=Noida&z=14&output=embed"
                className={`w-full h-full rounded transition-opacity duration-700 ${
                  isLoaded ? "opacity-100" : "opacity-0"
                }`}
                frameBorder="0"
                title="Google Map"
                referrerPolicy="no-referrer-when-downgrade"
                onLoad={() => setIsLoaded(true)}
              ></iframe>
            </div>

            {/* Contact Info */}
            <div className="bg-gray-100 rounded-lg p-8 h-80">
              <h4 className="text-[#00D084] text-2xl font-semibold mb-6">
                Get in Touch
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start space-x-4">
                  <FaMapMarkerAlt className="text-6xl text-[#00D084] mt-1" />
                  <div>
                    <h4 className="text-2xl font-semibold">Address</h4>
                    <p className="text-gray-700 text-lg">
                      505, Tower A-1, Corporate Park, Noida-201301, Uttar
                      Pradesh, India
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <FaEnvelope className="text-4xl text-[#00D084] mt-1" />
                  <div>
                    <h4 className="text-2xl font-semibold">Mail Us</h4>
                    <p className="text-gray-700 text-lg">presales@ajeevi.com</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <FaPhoneAlt className="text-3xl text-[#00D084] mt-1" />
                  <div>
                    <h4 className="text-2xl font-semibold">Telephone</h4>
                    <p className="text-gray-700 text-lg">+91-9654323500</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <FaFirefoxBrowser className="text-4xl text-[#00D084] mt-1" />
                  <div>
                    <h4 className="text-2xl font-semibold">Website</h4>
                    <p className="text-gray-700 text-lg">
                      <a href="http://www.ajeevi.com">http://www.ajeevi.com</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;